import { render, staticRenderFns } from "./assignmentItem.vue?vue&type=template&id=3fb9d38c&scoped=true"
import script from "./assignmentItem.vue?vue&type=script&lang=js"
export * from "./assignmentItem.vue?vue&type=script&lang=js"
import style0 from "./assignmentItem.vue?vue&type=style&index=0&id=3fb9d38c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb9d38c",
  null
  
)

export default component.exports